import { AppPage } from '../../types';

export default {
  Home: {
    name: AppPage.Home,
    path: '/',
  },
  Account: {
    name: AppPage.Account,
    path: '/account',
  },
  PersonalInfo: {
    name: AppPage.PersonalInfo,
    path: '/account/personal-info',
  },
  Communications: {
    name: AppPage.Communications,
    path: '/account/communications',
  },
  ConnectedAccounts: {
    name: AppPage.ConnectedAccounts,
    path: '/account/connected-accounts',
  },
  AddUser: {
    name: AppPage.AddUser,
    path: '/organisation/users/add',
  },
  ContactUs: {
    name: AppPage.ContactUs,
    path: '/contact-us',
  },
  MyOrganisation: {
    name: AppPage.MyOrganisation,
    path: '/organisation',
  },
  ProfessionalDevelopmentApprovals: {
    name: AppPage.ProfessionalDevelopmentApprovals,
    path: '/pda/bookings',
    featureFlag: 'mycambridge.professionalDevelopmentApprovals',
  },
  Callback: {
    path: '/callback',
  },
};
